import { UpdatePageLayout } from 'framework/ui/layout';
import LeaveEntityHeader from 'domain/people/leave/shared/LeaveEntityHeader';
import UpdateLeaveBreadcrumbs from 'domain/people/leave/createupdate/Update/Breadcrumbs';
import LeaveForm from 'domain/people/leave/createupdate/LeaveForm';
import useLeaveService from 'domain/people/leave/shared/leaveService';
import { mapLeaveDtoToFormLeaveData } from 'domain/people/leave/shared/leaveMappers';
import useLeavesErrorMap from 'domain/people/leave/createupdate/errorHandlers';
import { useLeaveUrl } from 'domain/people/leave/leaveRouting';
import LeaveNotStrictRulesHandler from '../LeaveNotStictRulesHandler';
import { UpdateForm } from 'framework/form';

const UpdateLeave = () => {
  const { update, getById, getValidationSchema } = useLeaveService();
  const errorsMap = useLeavesErrorMap();
  const { getSingleEntityUrl } = useLeaveUrl();

  const getDataForm = async (id: string) => {
    const leaveData = await getById(id);
    return mapLeaveDtoToFormLeaveData(leaveData);
  };

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getDataForm}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Leave has been successfully saved.',
      }}
      errorsMap={errorsMap}
    >
      <LeaveNotStrictRulesHandler errorMap={errorsMap} />
      <UpdatePageLayout
        title="Edit: Leave"
        breadcrumbs={<UpdateLeaveBreadcrumbs />}
        entityHeader={<LeaveEntityHeader />}
      >
        <LeaveForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateLeave;
